import { useContext } from 'react'

import {
  SanityPrintAreaType,
  SanityPrintPermission,
} from '@data/sanity/queries/types/print'
import { SanityProductVariantFragment } from '@data/sanity/queries/types/product'
import { SanityShopPrint } from '@data/sanity/queries/types/shop'
import { CartContext } from '@lib/cart'
import { getIsPrintSlotSubmitButtonDisabled } from '@lib/print/shop'
import { getPrintSlotSubmitButtonText } from '@lib/print/text'
import { SlotWithConfiguration } from '@lib/print/types'
import { StringsContext } from '@lib/strings-context'

import Button from '@components/buttons/button'

interface PrintConfiguratorSlotSubmitButtonProps {
  productVariant: SanityProductVariantFragment
  activeSlot: SlotWithConfiguration
  imageAreaTypes: SanityPrintAreaType[]
  activePrints: SanityShopPrint[]
  permissions?: SanityPrintPermission | null
  showAddToCartButton?: boolean
  onNextClick: () => void
  onAddToCartClick: () => void
}

const PrintConfiguratorSlotSubmitButton = ({
  productVariant,
  activeSlot,
  imageAreaTypes,
  activePrints,
  permissions,
  showAddToCartButton,
  onNextClick,
  onAddToCartClick,
}: PrintConfiguratorSlotSubmitButtonProps) => {
  const { isCartProductAdding } = useContext(CartContext)
  const strings = useContext(StringsContext)

  const isSubmitButtonDisabled = getIsPrintSlotSubmitButtonDisabled(
    activeSlot.configuration,
    imageAreaTypes,
    activePrints,
    productVariant,
    isCartProductAdding,
    showAddToCartButton,
    permissions,
  )
  const submitButtonText = getPrintSlotSubmitButtonText(
    strings,
    productVariant.inStock,
    !!showAddToCartButton,
    isCartProductAdding,
  )

  const handleClick = () => {
    if (isSubmitButtonDisabled) {
      return
    }

    if (showAddToCartButton && productVariant.inStock) {
      onAddToCartClick()
      return
    }

    onNextClick()
  }

  return (
    <Button
      variant="primary"
      color="red"
      size="normal-small"
      icon={showAddToCartButton ? 'Cart' : 'ArrowRight'}
      disabled={isSubmitButtonDisabled}
      onClick={handleClick}
    >
      {submitButtonText}
    </Button>
  )
}

export default PrintConfiguratorSlotSubmitButton
